import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import { Card, Title, Divider, Subtitle, StepHeader, BulletList, ListItem, StepSection } from "./StyledComponents";

interface IDemandTrendsAnomalyAgentPlaceHolder {
    keywordListName: string;
    date?: string;
    country?: string;
}

const i18nBase = "demand.trends.anomaly.agent.placeholder.";

const STEPS = [
    { header: "step1.header", bullets: ["step1.bullet1", "step1.bullet2"] },
    { header: "step2.header", bullets: ["step2.bullet1", "step2.bullet2"] },
    { header: "step3.header", bullets: ["step3.bullet1", "step3.bullet2"] },
];

const DemandTrendsAnomalyAgentPlaceHolder: FC<IDemandTrendsAnomalyAgentPlaceHolder> = (
    props: IDemandTrendsAnomalyAgentPlaceHolder,
) => {
    const { keywordListName, date, country } = props;
    return (
        <Card data-automation="demand-spike-agent-placeholder">
            <Title>{translate(`${i18nBase}title`, { keyword: keywordListName })}</Title>
            {date && country ? (
                <Subtitle>
                    {date}, {country}
                </Subtitle>
            ) : null}

            <Divider />

            {STEPS.map((step) => (
                <StepSection key={step.header}>
                    <StepHeader>{translate(`${i18nBase}${step.header}`)}</StepHeader>
                    <BulletList>
                        {step.bullets.map((bullet) => (
                            <ListItem key={bullet}>{translate(`${i18nBase}${bullet}`)}</ListItem>
                        ))}
                    </BulletList>
                </StepSection>
            ))}
        </Card>
    );
};

export default DemandTrendsAnomalyAgentPlaceHolder;
